<template>
    <base-collapse :is-open="this.isOpen">
        <template #title="slotProps">
            <div class="col-12 algolia-listing-filters">
                <div class="algolia-listing-filters__filter-block-wrapper">
                    <div
                        class="algolia-listing-filters__filter-block-header"
                        @click="slotProps.toggleIsActive"
                    >
                        <span
                            class="algolia-listing-filters__filter-block-header-text"
                            >{{ title }}</span
                        >
                        <svg
                            v-if="!slotProps.isActive"
                            class="algolia-listing-filters__filter-block-header-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                        <svg
                            v-else
                            class="algolia-listing-filters__filter-block-header-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 15l7-7 7 7"
                            />
                        </svg>
                    </div>
                    <div class="algolia-listing-filters__filter-items-checkbox">
                        <div
                            class="algolia-listing-filters__filter-item-wrapper"
                        >
                            <div
                                class="algolia-listing-filters__filter-item-checkbox-wrapper"
                            >
                                <span class="w-100" v-show="slotProps.isActive">
                                    <slot></slot>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </base-collapse>
</template>

<script>
import BaseCollapse from "../../BaseCollapse";

export default {
    components: {
        BaseCollapse
    },
    props: {
        title: {
            type: String,
            required: true
        },
        showSelected: {
            type: Boolean,
            default: false
        },
        selectedName: {
            type: String
        },
        isMobileStyling: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    }
};
</script>
